<a [routerLink]="[item.route]" routerLinkActive="link-active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMenu()">
  <div class="link-content">
    <mat-icon [ngClass]="{'ion-float-right': mode === 0, 'ion-justify-content-center': mode === 1 }">
      {{ item.icon }}
    </mat-icon>
    <span>{{item.name}}</span>
  </div>
</a>
